import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, map, mergeMap, of } from 'rxjs';
import { HeaderPageTitleConfig, HeaderSearchConfig } from '../models/header.models';
import { Router, ActivatedRoute, NavigationEnd, Data } from '@angular/router';
import { UserAuthenticationService } from '../../../../administration/src/lib/services/user-authentication.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private readonly defaultConfig: HeaderSearchConfig = {
    showSearch: false,
    placeholder: '',
    showIcon: false,
    showSearchResults: false,
    search: () => of([]),
    handleResult: () => {}
  };

  private searchConfig: HeaderSearchConfig = { ...this.defaultConfig };
  private searchConfigSubject = new BehaviorSubject<HeaderSearchConfig>({ ...this.defaultConfig });
  searchConfig$ = this.searchConfigSubject.asObservable();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public _authService: UserAuthenticationService
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        mergeMap(route => route.data)
      )
      .subscribe((data: Data) => {
        if (this.headerPageTitleConfigSubject.value.pageHeader.headerTemplate) return;

        const pageHeaderData = data['pageHeader'] || {};

        const config: HeaderPageTitleConfig = {
          pageHeader: {
            titleText: pageHeaderData['titleText'] || '',
            subtitleText: pageHeaderData['subtitleText'],
            titleIcon: pageHeaderData['titleIcon'],
            backButtonRoute: pageHeaderData['backButtonRoute']
          }
        };
        this.headerPageTitleConfigSubject.next({ ...config });
      });
  }

  setSearchConfig(config: Partial<HeaderSearchConfig>): void {
    this.searchConfig = { ...this.defaultConfig, ...config };
    this.searchConfigSubject.next({ ...this.searchConfig });
  }

  clearSearchConfig(): void {
    this.searchConfig = { ...this.defaultConfig };
    this.searchConfigSubject.next({ ...this.defaultConfig });
  }

  getSearchConfig(): HeaderSearchConfig {
    return { ...this.searchConfig };
  }

  private readonly defaultHeaderPageTitleConfig: HeaderPageTitleConfig = {
    pageHeader: { titleText: '' }
  };
  private headerPageTitleConfigSubject = new BehaviorSubject<HeaderPageTitleConfig>(this.defaultHeaderPageTitleConfig);
  headerPageTitleConfig$ = this.headerPageTitleConfigSubject.asObservable();

  setHeaderPageTitleConfig(config: HeaderPageTitleConfig): void {
    this.headerPageTitleConfigSubject.next({ ...config });
  }

  getHeaderPageTitleConfig(): HeaderPageTitleConfig {
    return this.headerPageTitleConfigSubject.value;
  }
}
